import React from 'react'
import PropTypes from 'prop-types'
import CopyButton from './CopyButton'

const TestSnippet = ({ copied, setCopied, options, token }) => {
  const testingWidgetCode = `var script = document.createElement('script');
    \n script.type = 'text/javascript';
    \n script.src = 'https://onlineschedulingv2.threadcommunication.com';
    \n script.onload = () => { OpenChair.init({ token: "${token}",${options} }) };
    \n document.head.appendChild(script);`

  return (
    <div>
      <p>
        To test the widget before sending this code to the dev, use the button
        below to copy and paste test code into the console on their website.
      </p>
      <CopyButton
        buttonText="Copy Test Code to Clipboard"
        copied={copied}
        setCopied={setCopied}
        strToCopy={testingWidgetCode}
      />
    </div>
  )
}

TestSnippet.propTypes = {
  copied: PropTypes.bool.isRequired,
  setCopied: PropTypes.func.isRequired,
  options: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
}

export default TestSnippet



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/TestSnippet.js